/**
 * R51 D3 v2 — Cover gradient palette(從 `ProjectListPage` 抽出的純結構重構,行為不變)
 * -----------------------------------------------------------------------------
 * 對齊 `M-12_素材專案列表.html` cover-letter 4 色 gradient(line 59-62):
 *   - thumb-denim / thumb-food / thumb-warm / thumb-cool / cover-A (orange) / cover-D (purple)
 *
 * 派生策略:從 brandKit.colors.primary HEX 第一個 byte 取模 6 套對應預設 gradient。
 * 沒 brandKit 走 'cover-D' 紫色 fallback。
 */
const COVER_GRADIENTS = [
  // thumb-denim — 對齊 mockup line 41-44(深藍丹寧質感)
  'radial-gradient(ellipse at 30% 30%, var(--denim-500) 0%, transparent 50%), radial-gradient(ellipse at 70% 70%, var(--denim-750) 0%, transparent 60%), repeating-linear-gradient(45deg, var(--denim-600) 0 2px, var(--denim-650) 2px 4px)',
  // thumb-food — 對齊 mockup line 27-32(暖橘食物色)
  'radial-gradient(ellipse at 30% 40%, var(--logo-grad-to) 0%, transparent 50%), radial-gradient(ellipse at 70% 70%, var(--amber-700) 0%, transparent 60%), repeating-linear-gradient(45deg, var(--amber-600) 0 2px, var(--amber-700) 2px 4px)',
  // thumb-warm — 對齊 mockup line 33-38(紅暖警示)
  'radial-gradient(ellipse at 30% 40%, var(--danger-300) 0%, transparent 55%), radial-gradient(ellipse at 70% 70%, var(--danger-600) 0%, transparent 65%), repeating-linear-gradient(45deg, var(--danger-500) 0 2px, var(--danger-600) 2px 4px)',
  // thumb-cool — 對齊 mockup line 39-44(藍冷)
  'radial-gradient(ellipse at 40% 30%, var(--info-300) 0%, transparent 55%), radial-gradient(ellipse at 70% 70%, var(--info-800) 0%, transparent 65%), repeating-linear-gradient(45deg, var(--info-500) 0 2px, var(--output-fg) 2px 4px)',
  // cover-A — 對齊 mockup line 59(橘 linear)
  'linear-gradient(135deg, var(--coral-300), var(--coral-500))',
  // cover-D — 對齊 mockup line 62(紫 linear,fallback)
  'linear-gradient(135deg, var(--purple-200), var(--purple-600))',
];

export function pickCoverGradient(primaryHex: string | undefined): string {
  if (!primaryHex) return COVER_GRADIENTS[5];
  const m = primaryHex.match(/^#?([0-9a-fA-F]{2})/);
  if (!m) return COVER_GRADIENTS[5];
  const b = parseInt(m[1], 16);
  return COVER_GRADIENTS[b % COVER_GRADIENTS.length];
}
